import TimeSeriesLegend from 'utils/components/TimeSeriesChart/TimeSeriesLegend';
import React from 'react';
import { TooltipText } from 'utils/components/Tooltip/Tooltip';
import { useToggleConfigOption } from 'widgets/store/configuration/hooks';
import { BooleanKeys } from 'utils/types/BooleanKeys';
import { WidgetLegend } from 'widgets/WidgetLegend/WidgetLegend';

export interface WidgetTimeSeriesLegendProps<TConfig> {
    alignDropdown?: 'left' | 'center' | 'right';
    className: string;
    label: string;
    value?: string;
    hideSeriesPropertyName: BooleanKeys<TConfig> & string;
    containerLeft: number;
    onClick?: () => void;
    twoColourBorder?: boolean;
    suffix?: string;
    tooltip?: TooltipText;
}

export function WidgetTimeSeriesLegend<TConfig>(
    props: WidgetTimeSeriesLegendProps<TConfig>
) {
    const {
        alignDropdown,
        className,
        label,
        value,
        hideSeriesPropertyName,
        containerLeft,
        tooltip,
        twoColourBorder,
        suffix,
    } = props;

    const { value: seriesHidden, toggle: toggleSeriesHidden } =
        useToggleConfigOption<TConfig>(hideSeriesPropertyName);

    const hideLegendPropertyName =
        `${hideSeriesPropertyName}Legend` as BooleanKeys<TConfig>;

    return (
        <WidgetLegend
            alignDropdown={alignDropdown}
            hideLegendPropertyName={hideLegendPropertyName}
            showSeries={!seriesHidden}
            toggleShowSeries={toggleSeriesHidden}
        >
            <TimeSeriesLegend
                className={className}
                label={label}
                value={value}
                twoColourBorder={twoColourBorder}
                containerLeft={containerLeft}
                disabled={seriesHidden}
                onClick={toggleSeriesHidden}
                tooltip={tooltip}
                suffix={suffix}
            />
        </WidgetLegend>
    );
}
